import { useQuery } from '@tanstack/react-query';
import type { AssignmentShiftList } from '../../../../../js/api';
import { AssignmentsService } from '../../../../../js/api';

export const ORG_PROVIDER_ASSIGNMENT_SHIFTS_QUERY_KEY = 'org-provider-assignment-shifts';
const SHIFTS_QUERY_KEY = ORG_PROVIDER_ASSIGNMENT_SHIFTS_QUERY_KEY;

type Args = {
  providerId: string | undefined;
  start: string;
  end: string;
};

/**
 * Fetch this organization's AssignmentShifts for a specific provider within a
 * date window, for the org Create-Assignment calendar's booked-day overlay.
 *
 * Entity-scoping comes from AssignmentShiftViewSet's SecurityContextMixin
 * (`healthcare_entity_security_field = "assignment__healthcare_entity_id"`):
 * the server only returns shifts belonging to the requesting rep's entity.
 * The `provider` query param narrows to one provider; the viewset rejects
 * calls from org reps that omit it.
 *
 * Disabled until a provider is selected.
 */
export const useOrgProviderAssignmentShifts = ({ providerId, start, end }: Args) => {
  return useQuery({
    queryKey: [SHIFTS_QUERY_KEY, providerId, { start, end }],
    queryFn: async (): Promise<AssignmentShiftList[]> =>
      AssignmentsService.assignmentsAssignmentShiftList({
        provider: providerId,
        startOnAfter: start,
        startOnBefore: end,
      }),
    enabled: !!providerId && !!start && !!end,
    staleTime: 5 * 60 * 1000,
  });
};
